var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from 'aurelia-dependency-injection';
import * as jwt from 'jsonwebtoken';
import { Exception } from '../models/Exception';
export class TokenServiceConfig {
}
let TokenService = class TokenService {
    constructor(config) {
        this.config = config;
        this.BEARER_TOKEN_PATTERN = /Bearer /i;
    }
    /**
     * Strips the word Bearer from the token string. If the word Bearer is not
     * present then the string is returned unmodified.
     */
    stripBearer(token) {
        return token.replace(this.BEARER_TOKEN_PATTERN, '');
    }
    /**
     * Returns the decoded token payload without verifying the token signature.
     */
    decodePayload(token) {
        return jwt.decode(this.stripBearer(token));
    }
    /**
     * Returns the decoded token payload without verifying the token signature.
     */
    decodeHeader(token) {
        const { header } = jwt.decode(this.stripBearer(token), { complete: true });
        return header;
    }
    /**
     * Verifies a JWT using the sso public key corresponding to the keyId in the token header.
     */
    verify(token) {
        console.info('tokenService.verify');
        const { jwtClockTolerance = 60, ssoPublicKeys = [] } = this.config;
        try {
            const tokenWithoutBearer = this.stripBearer(token);
            const { header } = jwt.decode(tokenWithoutBearer, { complete: true });
            const keys = ssoPublicKeys.find((key) => key.keyId === header.kid);
            const secret = keys ? keys.publicKey : undefined;
            const algorithm = 'RS256';
            if (!secret) {
                throw new Error(`Could not find a key to verify token with kid ${header.kid}. Expected one of ${ssoPublicKeys.map((k) => k.keyId).join(', ')}`);
            }
            return jwt.verify(tokenWithoutBearer, secret, { clockTolerance: jwtClockTolerance, algorithms: [algorithm] });
        }
        catch (error) {
            throw new Exception(error.message, 401, error);
        }
    }
};
TokenService = __decorate([
    autoinject,
    __metadata("design:paramtypes", [TokenServiceConfig])
], TokenService);
export { TokenService };
//# sourceMappingURL=TokenService.js.map